<template>
  <!-- Tipo Fuente de datos -->
  <div class="grid m-0">
    <!-- Filters mode 1 -->
    <div class="col-12">
      <TopSection
        :filtros="report.Filtros"
        :estadisticas="report.Estadisticas"
      />
    </div>

    <!-- Filters mode 2 -->
    <div class="col-12 sm:col-4 md:col-2">
      <LeftSection :filtros="report.Filtros" />
    </div>

    <!-- Table -->
    <div class="col-12 sm:col-8 md:col-10">
      <ChartsSection :graficos="report.Graficos" />
    </div>
    <div v-if="report.PiePagina" class="col-12">
      <div v-html="report.PiePagina"></div>
    </div>
  </div>
</template>

<script setup>
import TopSection from "@/pages/_root/views/reports-details/sections/TopSection.vue"; // eslint-disable-line
import LeftSection from "@/pages/_root/views/reports-details/sections/LeftSection.vue"; // eslint-disable-line
import ChartsSection from "@/pages/_root/views/reports-details/chart-type/ChartsSection.vue"; // eslint-disable-line

// #region Props, Emits
defineProps({
  report: {
    type: Object,
    required: true,
  },
});
// #endregion

// #region  Params, Ref, Reactives, Computed
// #endregion

// #region Functions
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>